import { BlurEffect2D } from "../display/effect2d/BlurEffect2D";
import { ClassUtils } from "../utils/ClassUtils";
import { Filter } from "./Filter";
export class BlurFilter extends Filter {
    getEffect() {
        return this._effect2D;
    }
    constructor(strength = 4) {
        super();
        this._effect2D = new BlurEffect2D(strength);
    }
    get strength() {
        return this._effect2D.strength;
    }
    set strength(v) {
        this._effect2D.strength = v;
        this.onChange();
    }
}
ClassUtils.regClass("BlurFilter", BlurFilter);
